module.exports = __webpack_public_path__ + "img/inventory-log-book_B09Q8YMBG7.b2685821.jpg";